import _ from 'lodash'
import routes from './app.routes'

function configure($routeProvider) {
  addRoutes(routes)

  function addRoutes(routes) {
    _.map(routes, addRoute)
  }

  function addRoute(routeOptions, path) {
    $routeProvider.when(path, routeOptions)
  }
}

configure.$inject = ['$routeProvider']

export default configure
